import { logToMezmo } from './mezmo'

export const logger = {
	info: (...data) => {
		// eslint-disable-next-line
		console.info(...data)
		logToMezmo(data, 'INFO')
	},
	warn: (...data) => {
		// eslint-disable-next-line
		console.warn(...data)
		logToMezmo(data, 'WARN')
	},
	error: (...data) => {
		// eslint-disable-next-line
		console.error(...data)
		logToMezmo(data, 'ERROR')
	},
}
